import { toWSDateString } from "@wingspanhq/fe-component-library";

export const formatReportsDate = (date?: Date) => {
  return date ? toWSDateString(date, "mobileInput") : undefined;
};
